import { __decorate } from "tslib";
import { Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import { Api } from '@/domains/api';
let VersionStore = class VersionStore extends VuexModule {
    constructor() {
        super(...arguments);
        this.versions = [];
    }
    async fetch() {
        try {
            const response = await Api.Version.Get();
            return {
                versions: response.data,
            };
        }
        catch {
            return {
                versions: [],
            };
        }
    }
};
__decorate([
    MutationAction({ mutate: ['versions'] })
], VersionStore.prototype, "fetch", null);
VersionStore = __decorate([
    Module({
        namespaced: true,
    })
], VersionStore);
export default VersionStore;
export * from './type';
